import {
  ISpreadsheet,
  ICustomAttribute,
  ITag,
  DriveType,
} from '../../../../interfaces/graph-types';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { AccountService } from '../../../../services/account.service';
import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable, Subscription, Subject } from 'rxjs';
import { IDrive } from '../../../../interfaces/graph-types';
import { PusherService } from '../../../../services/pusher.service';
import { take, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ImportCandidatesFormOutputData } from '../import-candidates-form/import-candidates-form.component';

@Component({
  selector: 'import-candidates-gmail',
  template: require('./import-candidates-gmail.component.pug'),
  styles: [require('./import-candidates-gmail.component.css').toString()],
})
export class ImportCandidatesGmailComponent implements OnInit {
  @Input()
  modalRef: BsModalRef;

  drives$: Observable<IDrive[]>;
  selectedDrive: IDrive = null;
  gmails: IDrive[] = [];
  spreadsheets$: Observable<ISpreadsheet[]> = null;
  selected_spreadsheet: ISpreadsheet = null;
  handshake_id: string;

  pusherpreview: Subscription = null;

  stage: number = 0;

  filter: string = '';

  data: any = null;

  email: any = null;
  firstName: any = null;
  lastName: any = null;
  company: any = null;
  title: any = null;
  role: any = null;
  phone: any = null;
  score: any = null;
  subatt: Subscription = null;
  subtag: Subscription = null;
  subfunnel: Subscription = null;
  subgroup: Subscription = null;

  tags = [];
  attributes = [];
  funnels = [];
  groups = [];

  isFormSubmitting = false;
  formSubmitError?: string;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private watch_account: WatchAccountService,
    private accountService: AccountService,
    private pusherService: PusherService,
    private cd: ChangeDetectorRef,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.searchChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => this.startSearch(model));

    this.drives$ = this.accountService.drives(
      this.watch_account.accountId().getValue(),
      DriveType.GDrive,
    );

    this.subatt = this.accountService
      .candidateAttributes(this.watch_account.accountId().getValue())
      .subscribe(data => {
        if (data) {
          this.attributes = [];
          data.forEach((attribute: ICustomAttribute) => {
            this.attributes.push(attribute);
          });
        }
      });

    this.subtag = this.accountService
      .candidateTags(this.watch_account.accountId().getValue())
      .subscribe(data => {
        if (data) {
          this.tags = [];
          data.forEach((tag: ITag) => {
            this.tags.push(tag);
          });
        }
      });

    this.subfunnel = this.accountService
      .funnelsNames(this.watch_account.accountId().getValue())
      .subscribe(funnels => {
        if (funnels) {
          this.funnels = funnels;
        }
      });

    this.subgroup = this.accountService
      .groups(this.watch_account.accountId().getValue())
      .subscribe(groups => {
        if (groups) {
          console.warn({ groups });
          this.groups = groups;
        }
      });

    //this.spreadsheets$ = this.drive_service.spreadsheets(24342);

    this.pusherpreview = this.pusherService
      .spreadsheetPreview()
      .subscribe(data => {
        // check that handshake_id is the correct one (to prevent seeing the preview of a team member uploading)
        if (data.data.sheet_id == this.selected_spreadsheet.id) {
          this.stage = 5;
          this.data = data.data;

          // otherwise, our stage change is not detected by the view
          this.refreshUI(); // this comes from pusher thread outside of Angular apparently :(
        }
      });

    this.checkGmailDrives();
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  refreshUI() {
    // also used by form after pusher initialised stage 5 :(
    this.cd.detectChanges();
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.pusherpreview) {
      this.pusherpreview.unsubscribe();
    }
    if (this.subatt) {
      this.subatt.unsubscribe();
    }
    if (this.subtag) {
      this.subtag.unsubscribe();
    }
    if (this.subfunnel) {
      this.subfunnel.unsubscribe();
    }
    if (this.subgroup) {
      this.subgroup.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  async checkGmailDrives() {
    // we take 2 because it sends null first, and we use take to close the observer or it will never finished waiting
    const drives = await this.drives$.pipe(take(2)).toPromise();
    // Here, we need to check if there are gmail drive
    // if only one, no worries, go to next stage
    // if more than one, need to select

    drives.forEach((item, index) => {
      if (item.type == 'gmail') {
        this.gmails.push(item);
      }
    });

    if (this.gmails.length == 0) {
      this.stage = 1;
    }
    if (this.gmails.length > 1) {
      this.stage = 2;
    }
    if (this.gmails.length == 1) {
      this.selectDrive(this.gmails[0]);
    }
  }

  searchChanged: Subject<any> = new Subject<any>();

  // -------------------------------------------------------------------
  filterChanged(newvalue) {
    this.searchChanged.next(newvalue);
    this.selectedDrive;
  }

  // -------------------------------------------------------------------
  startSearch(newvalue) {
    this.filter = newvalue;
    this.selectDrive(this.selectedDrive);
  }

  // -------------------------------------------------------------------
  selectDrive(drive: IDrive) {
    this.selectedDrive = drive;
    // console.log({ drive });
    this.spreadsheets$ = this.accountService.spreadsheets(
      drive.id,
      this.filter,
    );
    this.stage = 3;
  }

  // -------------------------------------------------------------------
  backToSelectDrive() {
    this.stage = 2;
    this.spreadsheets$ = null;
    this.selectedDrive = null;
    this.filter = '';
  }

  // -------------------------------------------------------------------
  backToSelectSpreadsheet() {
    this.data = null;
    this.email = null;
    this.firstName = null;
    this.lastName = null;
    this.company = null;
    this.title = null;
    this.role = null;
    this.phone = null;
    this.score = null;
    this.stage = 3;
  }

  // -------------------------------------------------------------------
  selectSpreadsheet(spreadsheet: ISpreadsheet) {
    spreadsheet.error = null;
    this.selected_spreadsheet = spreadsheet;
    this.stage = 4;
    this.accountService.fetchSpreadsheetColumns(
      this.selectedDrive.id,
      this.watch_account.accountId().getValue(),
      this.selected_spreadsheet.id,
      data => {
        this.handshake_id = data.handshake_id;
      },
      error => {
        // error, go back one stage
        spreadsheet.error = error;
        this.stage = 3;
      },
    );
  }

  // -------------------------------------------------------------------
  onImportFormSubmit(data: ImportCandidatesFormOutputData) {
    this.isFormSubmitting = true;
    this.formSubmitError = undefined;

    this.accountService.importCandidatesFromDrive(
      this.watch_account.accountId().getValue(),
      this.selectedDrive.id,
      this.selected_spreadsheet.name,
      this.selected_spreadsheet.id,
      data.mapping,
      data.funnel && data.funnel.id,
      data.group && data.group.id,
      data.updateCandidates,
      data.monitorChanges,
      () => {
        this.isFormSubmitting = false;
        this.stage = 6;
        this.refreshUI();
      },
      error => {
        this.isFormSubmitting = false;
        this.formSubmitError = error;
        this.refreshUI();
      },
    );
  }
}
